import React from 'react'

export const SubTitle = ({title}) => {
  return (
   <h2 className='text-blue font-pluto text-lg tracking-wider font-bold text-center mt-3 '>{title}</h2>
  )
}
